import { z } from 'zod/v4';

export const UUID_SCHEMA: z.ZodType<string> = z.uuid();
